import { CellContext } from "@tanstack/react-table";
import { useMemo } from "react";
import { useNumber } from "../../../hooks/useNumerFormatter";
import { useSecondsToTime } from "../../../hooks/useFormatDateInterval";

interface CellRendererProps<TData> {
  valueType: string;
  context: CellContext<TData, any>;
}

export const CellRenderer = <TData = {},>({
  valueType,
  context,
}: CellRendererProps<TData>) => {
  const number = useNumber();
  const secondsToTime = useSecondsToTime();

  const value = useMemo<string | any>(() => {
    const value = context.getValue();
    if (value === undefined) {
      return "";
    }

    switch (valueType) {
      case "number": {
        return number.format(value);
      }
      case "time": {
        return secondsToTime(Math.round(value / 1000));
      }
      case "percentage": {
        return `${(value * 100).toFixed(1)}%`;
      }
      default: {
        return value;
      }
    }
  }, [context]);

  return <span>{value}</span>;
};
